import { useState, useEffect } from 'react';
import config from '../config';
import { Purchase } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

interface FilterCriteria {
  ean: string;
}

const useFetchDevicePurchaseByEan = (filterCriteria: FilterCriteria) => {
  const [purchaseResponse, setPurchaseResponse] = useState<Purchase[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const refetch = () => setRefreshTrigger(prev => prev + 1);
  const { sessionState } = useSession();

  useEffect(() => {
    const fetchPurchaseDeviceByEan = async () => {
      try {
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/purchase/byean/${filterCriteria.ean}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        setPurchaseResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };

    if (filterCriteria.ean && filterCriteria.ean !== '') {
      fetchPurchaseDeviceByEan();
      setError('');
    } else {
      setError('EAN cannot be empty');
    }
  }, [filterCriteria.ean, refreshTrigger]);

  return { purchaseResponse, error, refetch };
};

export default useFetchDevicePurchaseByEan;
